import { useRef } from 'react'
import { useAxios } from '@/contexts/AxiosProvider'
import { useHall } from '@/contexts/HallProvider'
import {
  SpeakingRole,
  TurnStatus,
  formatStringToKey,
  BotArgumentRequest,
  BotArgumentResponse,
} from '@db8/shared'

export const useBotArgFetch = () => {
  const { hall, transcriptions, setHallMetadata } = useHall()
  const axios = useAxios()
  const controllerRef = useRef<AbortController | null>(null)

  const fetchAndPublishAiArg = async (
    botTeam: SpeakingRole,
    minutes: number,
    abbreviation: string,
    format: string,
  ) => {
    controllerRef.current = new AbortController()

    // Convert display format string to enum key
    const formatKey = formatStringToKey(format)

    const request: BotArgumentRequest = {
      resolution: hall.topic,
      transcriptions,
      minutes: minutes.toString(),
      botTeam: botTeam.toString(),
      abbreviation,
      format: formatKey,
    }

    const res = await axios.post<BotArgumentResponse>('/ai/bot-argument', request, {
      signal: controllerRef.current.signal,
    })

    // Handle new response structure with separate TTS and transcript text
    if (res?.data?.ttsText && res?.data?.transcriptText) {
      return {
        ttsText: res.data.ttsText,
        transcriptText: res.data.transcriptText,
      }
    }

    // Fallback to old structure
    return {
      ttsText: res?.data?.response,
      transcriptText: res?.data?.response,
    }
  }

  const cancelFetch = () => {
    controllerRef.current?.abort()
  }

  return {
    fetchAndPublishAiArg,
    cancelFetch,
  }
}
